import { ENVIRONMENT_GAME } from "@/resources/constants/games";
import { Vue } from "vue-property-decorator";

export class UtilitiesGames extends Vue {
  private static enviroment =
    process.env.VUE_APP_ENVIRONMENT !== "PRO"
      ? ENVIRONMENT_GAME.DEV
      : ENVIRONMENT_GAME.PRO;
  public static getUrlGame(
    gameType: string,
    room: string,
    name: string
  ): string {
    const url = this.enviroment + gameType + "room=" + room + "&player=" + name;
    return url;
  }
  public static openGameNewTab(
    gameType: string,
    room: string,
    name: string
  ): void {
    window.open(
      this.enviroment + gameType + "room=" + room + "&player=" + name,
      "_blank"
    );
  }
}

export default UtilitiesGames;
